module.exports = __webpack_public_path__ + "img/arrow-down-icon.53547f99.svg";